(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-author-picks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('author-picks')) {
    class AuthorPicks extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;

        this.form = this.querySelector('form');
        this.boxes = [...this.querySelectorAll('.author-picks__input')];
        this.button = this.querySelector('[data-add]');
        this.totalEl = this.querySelector('[data-total]');
        this.statusEl = this.querySelector('[data-status]');
        this.isBusy = false;

        const currency = this.dataset.currency || 'AUD';
        try {
          this.money = new Intl.NumberFormat('en-AU', { style: 'currency', currency });
        } catch (error) {
          this.money = null;
        }

        this.addEventListener('change', (event) => {
          if (event.target.matches('.author-picks__input')) {
            this.setStatus('');
            this.update();
          }
        });
        if (this.form) this.form.addEventListener('submit', (event) => this.addToCart(event));
        this.update();
      }

      get selectedIds() {
        return this.boxes.filter((box) => box.checked).map((box) => Number(box.value));
      }

      update() {
        let total = 0;

        this.boxes.forEach((box) => {
          // Only ticked books send a quantity, so ids and quantities stay paired
          // if the form is ever submitted without JavaScript
          const quantity = box.closest('.author-picks__item').querySelector('[data-quantity]');
          if (quantity) quantity.disabled = !box.checked;
          if (box.checked) total += Number(box.dataset.price) || 0;
        });

        if (this.totalEl) {
          this.totalEl.textContent = this.money ? this.money.format(total / 100) : '$' + (total / 100).toFixed(2);
        }

        if (this.button && !this.isBusy) {
          const count = this.selectedIds.length;
          this.button.disabled = count === 0;
          if (count === 0) {
            this.button.textContent = this.dataset.labelNone;
          } else if (count === 1) {
            this.button.textContent = this.dataset.labelOne;
          } else {
            this.button.textContent = this.dataset.labelMany.replace('[count]', count);
          }
        }
      }

      setStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
      }

      // Adds the ticked books the same way the theme's product form does:
      // one request to /cart/add.js that also asks for the cart drawer's new HTML,
      // then a cart:update event, which opens the drawer and updates the cart count.
      async addToCart(event) {
        event.preventDefault();
        const ids = this.selectedIds;
        if (this.isBusy || ids.length === 0) return;

        this.isBusy = true;
        this.setStatus('');
        this.button.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.labelAdding;

        // The theme declares Theme as a global const, so it isn't on window
        const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
        const addUrl = routes.cart_add_url || '/cart/add.js';
        const sectionIds = [...document.querySelectorAll('cart-component')]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);

        let added = false;
        try {
          const response = await fetch(addUrl.endsWith('.js') ? addUrl : addUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: ids.map((id) => ({ id, quantity: 1 })),
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || this.dataset.messageError);
          }

          added = true;
          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'author-picks',
                data: { source: 'product-form', itemCount: ids.length, sections: data.sections },
              },
            })
          );
          this.button.textContent = this.dataset.labelAdded;
          this.setStatus(this.dataset.messageAdded);
        } catch (error) {
          console.error('Essential author picks: add to cart failed', error);
          this.setStatus(error && error.message ? error.message : this.dataset.messageError, true);
        } finally {
          this.button.removeAttribute('aria-busy');
          const reset = () => {
            this.isBusy = false;
            this.update();
          };
          if (added) {
            setTimeout(() => {
              reset();
              this.setStatus('');
            }, 2500);
          } else {
            reset();
          }
        }
      }
    }

    customElements.define('author-picks', AuthorPicks);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-availability"] && !Shopify.designMode) return;
  try {
    const section = document.querySelector('[data-product-availability]');
  const openDrawer = section.querySelector('[data-open-drawer]');
  const input = section.querySelector('[data-input]');
  const inputSubmit = section.querySelector('[data-input-submit]');
  const results = section.querySelector('[data-results]');
  const geolocateButton = section.querySelector('[data-geolocate-button]');
  const selectedStore = section.querySelector('[data-selected-store]');
  const closeDrawer = document.querySelectorAll(
    '[data-product-availability-drawer-close]'
  );

  const australianPostcodes = JSON.parse(
    section.querySelector('[data-australian-postcodes-json]').textContent
  );
  const pickUpAvailabilities = JSON.parse(
    section.querySelector('[data-pick-up-availabilities-json]').textContent
  );
  const stockByLocation = JSON.parse(
    section.querySelector('[data-stock-by-location-json]').textContent
  );

  const getLocationStock = (locationId) => {
    const gid = `gid://shopify/Location/${locationId}`;
    const stock = stockByLocation[gid];
    return stock !== undefined ? stock : null;
  };

  const isLocationAvailable = (availability) => {
    const stock = getLocationStock(availability.location_id);
    if (stock !== null) return stock > 0;
    return (
      availability.available && variantAvailable && variantInventoryQuantity > 0
    );
  };

  const getAvailabilityText = (locationId) => {
  const stock = getLocationStock(locationId);
  if (stock !== null) {
    if (stock >= 100) return '100+ Available';
    if (stock >= 50) return '50+ Available';
  }
  return availableText;
};

  const resultsOriginalHTML = results.innerHTML;
  const noResultsText = section.getAttribute('data-no-results-text');
  const setStoreText = section.getAttribute('data-set-store-text');
  const storeSetText = section.getAttribute('data-store-set-text');
  const availableText = section.getAttribute('data-available-text');
  const notAvailableText = section.getAttribute('data-not-available-text');
  const iconAvailable = section.getAttribute('data-icon-available');
  const iconNotAvailable = section.getAttribute('data-icon-not-available');
  const variantAvailable = JSON.parse(
    section.getAttribute('data-variant-available')
  );
  const variantInventoryQuantity = JSON.parse(
    section.getAttribute('data-variant-inventory-quantity')
  );

  openDrawer.addEventListener('click', (e) => {
    e.preventDefault();
    document.body.classList.add('is-product-availability-drawer-open');
    document.body.setAttribute('data-lock-scroll', 'true');
    openDrawer.blur();

    setTimeout(() => {
      input.focus();
    }, 200);
  });

  closeDrawer.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.remove('is-product-availability-drawer-open');
      document.body.removeAttribute('data-lock-scroll');
    });
  });

  section.addEventListener('click', async (e) => {
    if (!e.target.matches('[data-geolocate-button]')) return;
    e.preventDefault();
    const thisLocation = await getGeolocation();
    if (!thisLocation || !thisLocation.lat || !thisLocation.long) return;

    returnResults(thisLocation);
  });

  inputSubmit.addEventListener('click', (e) => {
    e.preventDefault();
    const value = input.value;
    if (value.length < 1) return;

    const thisLocation = australianPostcodes.find(
      (postcode) => postcode.postcode === value
    );

    returnResults(thisLocation);
  });

  const returnResults = (thisLocation) => {
    results.innerHTML = resultsOriginalHTML;

    const sortedAvailabilities = pickUpAvailabilities.sort((a, b) => {
      if (!thisLocation) return 0;

      return (
        haversine_distance_km(
          thisLocation.lat,
          thisLocation.long,
          a.latitude,
          a.longitude
        ) -
        haversine_distance_km(
          thisLocation.lat,
          thisLocation.long,
          b.latitude,
          b.longitude
        )
      );
    });

    sortedAvailabilities.forEach((availability) => {
      const available = isLocationAvailable(availability);

      results.innerHTML += `
        <div class="product-availability__result">
          <div class="product-availability__result-content">
            <span class="product-availability__result-name h6">${
              availability.name
            }</span>
          <span class="product-availability__result-address">
          ${availability.address ? `${availability.address}, ` : ''}${
        availability.city ? `${availability.city}, ` : ''
      }${
        availability.province_code
          ? availability.province_code
          : availability.province
          ? availability.province
          : ''
      } ${availability.zip ? availability.zip : ''}
          </span>
            <span class="product-availability__result-distance">${
              thisLocation && thisLocation.lat && thisLocation.long
                ? `${haversine_distance_km(
                    thisLocation.lat,
                    thisLocation.long,
                    availability.latitude,
                    availability.longitude
                  )} km`
                : ''
            }</span>
            <span class="product-availability__result-availability ${
              available ? 'is-available' : ''
            }">${
        available
          ? `${iconAvailable} ${getAvailabilityText(availability.location_id)}`
          : `${iconNotAvailable} ${notAvailableText}`
      }</span>
          </div>
          <button class="product-availability__set-store-button button is-tertiary" 
            data-set-store="${availability.name}"
          >
            ${
              getCookie('selected_store') === availability.name
                ? storeSetText
                : setStoreText
            }
          </button>
        </div>
      `;
    });

    if (sortedAvailabilities.length === 0) {
      results.innerHTML = `
        <div class="product-availability__result">
          <span class="product-availability__result-name">${noResultsText}</span>
        </div>
      `;
    }

    // Add event listeners to the newly created buttons
    const setStoreButtons = results.querySelectorAll('[data-set-store]');
    setStoreButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const storeName = e.target.getAttribute('data-set-store');
        setStoreCookie(storeName);

        setStoreButtons.forEach(
          (button) => (button.textContent = setStoreText)
        );
        e.target.textContent = storeSetText;

        // Close drawer
        document.body.classList.remove('is-product-availability-drawer-open');
        document.body.removeAttribute('data-lock-scroll');
      });
    });
  };

  // Input event with modern validation
  input.addEventListener('input', (e) => {
    // Remove non-digits immediately (modern approach)
    const numbersOnly = e.target.value.replace(/\D/g, '');

    // Enforce 4-digit limit
    e.target.value = numbersOnly.slice(0, 4);

    // Validate and update button state
    validateInput(input, inputSubmit);
  });

  // Prevent non-numeric input (additional layer of protection)
  input.addEventListener('keydown', (e) => {
    // Submit on Enter key if input is valid
    if (e.key === 'Enter') {
      e.preventDefault();
      if (validateInput(input, inputSubmit)) {
        inputSubmit.click();
      }
      return;
    }
    // Allow control keys (backspace, delete, arrow keys, etc.)
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
      'Tab',
    ];

    // Allow digits
    const isDigit = /^[0-9]$/.test(e.key);

    // Allow if it's a control key or digit (and not exceeding max length)
    if (allowedKeys.includes(e.key) || (isDigit && input.value.length < 4)) {
      return;
    }

    // Prevent all other keys
    e.preventDefault();
  });

  // Paste handling for modern browsers
  input.addEventListener('paste', (e) => {
    e.preventDefault();

    const pastedText = (e.clipboardData || window.clipboardData).getData(
      'text'
    );
    const numbersOnly = pastedText.replace(/\D/g, '').slice(0, 4);

    input.value = numbersOnly;
    validateInput(input, inputSubmit);
  });

  // Initialize button state on page load
  validateInput(input, inputSubmit);

  function validateInput(input, button) {
    const value = input.value;
    const isValid = /^\d{4}$/.test(value); // Exactly 4 digits using regex

    button.disabled = !isValid;
    button.setAttribute('aria-disabled', !isValid);

    // Update form validity state
    if (value.length === 0) {
      input.setCustomValidity('');
    } else if (value.length < 4) {
      input.setCustomValidity('Please enter exactly 4 digits');
    } else if (!/^\d+$/.test(value)) {
      input.setCustomValidity('Please enter numbers only');
    } else {
      input.setCustomValidity('');
    }

    return isValid;
  }

  function getGeolocation() {
    return new Promise((resolve, reject) => {
      if (!('geolocation' in navigator)) {
        console.error('Geolocation is not supported by this browser.');
        resolve(null);
        return;
      }

      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      function success(position) {
        const lat = position.coords.latitude;
        const long = position.coords.longitude;
        resolve({ lat, long });
      }

      function error(err) {
        console.error(`Error getting location: ${err.code} - ${err.message}`);
        resolve(null);
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
    });
  }

  function haversine_distance_km(lat1, long1, lat2, long2) {
    var R = 6371; // Radius of the Earth in km
    var rlat1 = lat1 * (Math.PI / 180);
    var rlat2 = lat2 * (Math.PI / 180);
    var difflat = rlat2 - rlat1;
    var difflong = (long2 - long1) * (Math.PI / 180);
    var d =
      2 *
      R *
      Math.asin(
        Math.sqrt(
          Math.sin(difflat / 2) * Math.sin(difflat / 2) +
            Math.cos(rlat1) *
              Math.cos(rlat2) *
              Math.sin(difflong / 2) *
              Math.sin(difflong / 2)
        )
      );
    return d.toFixed(1);
  }

  // Function to get cookie value
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
      return decodeURIComponent(parts.pop().split(';').shift());
    return null;
  }

  // Function to set store cookie
  function setStoreCookie(storeName) {
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1); // Cookie expires in 1 year

    document.cookie = `selected_store=${encodeURIComponent(
      storeName
    )}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;

    // Update the selected store display
    displaySelectedStore();
  }

  // Function to display selected store
  function displaySelectedStore() {
    const selectedStoreName = getCookie('selected_store');

    if (!selectedStoreName) {
      selectedStore.innerHTML = '';
      return;
    }

    // Find the matching availability from our data
    const matchingAvailability = pickUpAvailabilities.find(
      (availability) => availability.name === selectedStoreName
    );

    if (matchingAvailability) {
      const available = isLocationAvailable(matchingAvailability);

      selectedStore.innerHTML = `
        <div class="product-availability__result">
          <div class="product-availability__result-content">
            <span class="product-availability__result-name h6">${
              matchingAvailability.name
            }</span>
            <span class="product-availability__result-address">
          ${
            matchingAvailability.address
              ? `${matchingAvailability.address}, `
              : ''
          }${
        matchingAvailability.city ? `${matchingAvailability.city}, ` : ''
      }${
        matchingAvailability.province_code
          ? matchingAvailability.province_code
          : matchingAvailability.province
          ? matchingAvailability.province
          : ''
      } ${matchingAvailability.zip ? matchingAvailability.zip : ''}
          </span>
            <span class="product-availability__result-availability ${
              available ? 'is-available' : ''
            }">${
        available
          ? `${iconAvailable} ${availableText}`
          : `${iconNotAvailable} ${notAvailableText}`
      }</span>
          </div>
        </div>
      `;
    } else {
      selectedStore.innerHTML = '';
    }
  }

  // Display selected store on page load
  displaySelectedStore();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-bible-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bible-accessories')) {
    const POPUP_SECTION = 'bible-accessories-popup';
    const POPUP_LIMIT = 24;
    const CACHE_MINUTES = 30;
    const TILE_SIZES = '(min-width: 990px) 80px, 64px';
    const popupCache = new Map();
    const algoliaRequests = new Map();
    const touchedKinds = new Set();
    let popup = null;
    let synced = false;

    const escapeHtml = (text) =>
      String(text ?? '').replace(/[&<>"']/g, (character) => `&#${character.charCodeAt(0)};`);

    // ---------- Algolia: the same order and merchandising as the collection pages ----------

    // The Algolia app puts its public, search-only settings on every page
    const getAlgolia = () => {
      const root = window.algoliaShopify;
      const config = (root && (root.config || root)) || {};
      const appId = config.app_id || config.appId || config.application_id;
      const apiKey = config.search_api_key || config.searchApiKey || config.api_key;
      if (!appId || !apiKey) return null;
      const prefix = config.index_prefix ?? config.indexPrefix ?? 'shopify_';
      return { appId, apiKey, indexName: `${prefix}products` };
    };

    const readCache = (id) => {
      try {
        const saved = JSON.parse(sessionStorage.getItem(`bible-acc:${id}`));
        if (saved && Date.now() - saved.time < CACHE_MINUTES * 60000) return saved.hits;
      } catch (error) {}
      return null;
    };
    const writeCache = (id, hits) => {
      try {
        sessionStorage.setItem(`bible-acc:${id}`, JSON.stringify({ time: Date.now(), hits }));
      } catch (error) {}
    };

    // Only what a tile needs from each Algolia record (one record per variant)
    const slimHit = (hit) => ({
      variantId: String(hit.objectID),
      title: hit.title || '',
      handle: hit.handle || '',
      image: hit.product_image || hit.image || '',
      price: Math.round(Number(hit.price) * 100) || 0,
      compare: Math.round(Number(hit.compare_at_price) * 100) || 0,
    });

    // In-stock items for each collection, in Algolia's order. One request for all
    // the collections asked for together; results are kept for the browser session.
    // Returns { [collectionId]: Promise<items> }
    const algoliaItems = (collections) => {
      const algolia = getAlgolia();
      const results = {};
      const missing = [];

      collections.forEach((collection) => {
        const cached = readCache(collection.id);
        if (cached) results[collection.id] = Promise.resolve(cached);
        else if (algoliaRequests.has(collection.id)) results[collection.id] = algoliaRequests.get(collection.id);
        else missing.push(collection);
      });
      if (missing.length === 0) return results;
      if (!algolia) {
        missing.forEach((collection) => {
          results[collection.id] = Promise.reject(new Error('Algolia settings not found on this page'));
        });
        return results;
      }

      const url =
        `https://${algolia.appId}-dsn.algolia.net/1/indexes/*/queries` +
        `?x-algolia-application-id=${encodeURIComponent(algolia.appId)}` +
        `&x-algolia-api-key=${encodeURIComponent(algolia.apiKey)}`;
      const body = {
        requests: missing.map((collection) => ({
          indexName: algolia.indexName,
          params: new URLSearchParams({
            query: '',
            filters: `collection_ids:"${collection.id}"`,
            ruleContexts: JSON.stringify([collection.handle, 'shopify_default_collection']),
            distinct: 'true',
            hitsPerPage: '48',
            attributesToRetrieve: JSON.stringify(['objectID', 'id', 'title', 'handle', 'product_image', 'image', 'price', 'compare_at_price', 'inventory_available']),
            attributesToHighlight: '[]',
            analytics: 'false',
            clickAnalytics: 'false',
          }).toString(),
        })),
      };
      // Sent as a "simple" request, like Algolia's own client, so there's no preflight
      const request = fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: JSON.stringify(body),
      }).then((response) => {
        if (!response.ok) throw new Error(`Algolia HTTP ${response.status}`);
        return response.json();
      });

      missing.forEach((collection, index) => {
        const items = request.then((data) => {
          const hits = ((data.results && data.results[index] && data.results[index].hits) || [])
            // Records must be per variant, so objectID is something the cart accepts
            .filter((hit) => hit.inventory_available !== false && hit.handle && String(hit.objectID) !== String(hit.id))
            .map(slimHit);
          writeCache(collection.id, hits);
          return hits;
        });
        items.catch(() => algoliaRequests.delete(collection.id));
        algoliaRequests.set(collection.id, items);
        results[collection.id] = items;
      });
      return results;
    };

    // Same shortening as snippets/bible-accessory-name.liquid
    const SIZE_WORDS = ['Extra Large', 'Extra-Large', 'X-Large', 'XLarge', 'XL', 'Extra Small', 'Extra-Small', 'X-Small', 'XSmall', 'XS', 'Large', 'Medium', 'Small'];
    const shortName = (title) => {
      const full = String(title).trim();
      let name = full;
      if (name.slice(0, 11).toLowerCase() === 'bible cover') {
        let padded = ` ${name.slice(11).trim()} `;
        for (const word of SIZE_WORDS) {
          if (padded.includes(` ${word}: `)) {
            padded = padded.replace(` ${word}: `, ' ');
            break;
          }
          if (padded.includes(` ${word} `)) {
            padded = padded.replace(` ${word} `, ' ');
            break;
          }
        }
        name = padded.trim();
      }
      if (name.slice(0, 9).toLowerCase() === 'bookmark ') name = name.slice(9).trim();
      for (let i = 0; i < 3 && /^[:\-,|]/.test(name); i++) name = name.slice(1).trim();
      return name || full;
    };

    const imageSet = (src) => {
      if (!src) return '';
      const sized = (width) => `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
      return `<img src="${escapeHtml(sized(240))}" srcset="${escapeHtml(sized(120))} 120w, ${escapeHtml(sized(240))} 240w" sizes="(min-width: 990px) 160px, 45vw" loading="lazy" alt="" width="240" height="240">`;
    };

    // The same markup as sections/bible-accessories-popup.liquid
    const optionHtml = (item, money, chooseLabel) => {
      const url = `/products/${encodeURIComponent(item.handle)}`;
      const compare = item.compare > item.price ? `<s class="author-picks__compare">${money(item.compare)}</s>` : '';
      return `
        <div class="bible-acc-option" data-option data-variant-id="${escapeHtml(item.variantId)}" data-price="${item.price}" data-url="${url}" data-title="${escapeHtml(item.title)}">
          <a class="bible-acc-option__image" href="${url}" tabindex="-1" aria-hidden="true" data-option-image>${imageSet(item.image)}</a>
          <a class="bible-acc-option__name" href="${url}" title="${escapeHtml(item.title)}" data-option-name>${escapeHtml(shortName(item.title))}</a>
          <span class="bible-acc-option__price" data-option-price>${compare}${money(item.price)}</span>
          <button type="button" class="button is-secondary bible-acc-option__choose" data-choose>${escapeHtml(chooseLabel)}</button>
        </div>`;
    };

    // ---------- Section Rendering API: Shopify's order, used when Algolia isn't there ----------

    const loadSectionOptions = (href) => {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('section_id', POPUP_SECTION);
      // Previewing an unpublished theme: ask for that theme's copy of the section
      const theme = window.Shopify && window.Shopify.theme;
      if (theme && theme.id && theme.role && theme.role !== 'main') {
        url.searchParams.set('preview_theme_id', theme.id);
      }
      const key = url.toString();

      if (!popupCache.has(key)) {
        const request = fetch(key, { headers: { Accept: 'text/html' } })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status} from ${key}`);
            return response.text();
          })
          .then((html) => {
            const options = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-options]');
            if (!options) {
              throw new Error(`No popup list in the response from ${key}. Is sections/${POPUP_SECTION}.liquid in this theme?`);
            }
            return options.outerHTML;
          });
        // Let a failed request be tried again next time
        request.catch(() => popupCache.delete(key));
        popupCache.set(key, request);
      }

      return popupCache.get(key);
    };

    // ---------- Popup ----------

    // One shared dialog for every Complete your Bible block on the page
    const getPopup = (labels) => {
      if (popup) return popup;

      const dialog = document.createElement('dialog');
      dialog.className = 'bible-acc-dialog';
      dialog.setAttribute('aria-labelledby', 'bible-acc-dialog-title');
      dialog.innerHTML = `
        <div class="bible-acc-dialog__header">
          <h2 class="bible-acc-dialog__title" id="bible-acc-dialog-title" data-title></h2>
          <button type="button" class="bible-acc-dialog__close" data-close aria-label="${escapeHtml(labels.close)}">
            <svg viewBox="0 0 18 18" aria-hidden="true" focusable="false"><path d="M2 2l14 14M16 2L2 16" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          </button>
        </div>
        <p class="bible-acc-dialog__note" data-note></p>
        <div class="bible-acc-dialog__body" data-body></div>
        <div class="bible-acc-dialog__footer">
          <span class="bible-acc-dialog__hint">${escapeHtml(labels.hint)}</span>
          <a class="bible-acc-dialog__all" data-all></a>
        </div>`;
      document.body.appendChild(dialog);

      popup = {
        dialog,
        title: dialog.querySelector('[data-title]'),
        note: dialog.querySelector('[data-note]'),
        body: dialog.querySelector('[data-body]'),
        all: dialog.querySelector('[data-all]'),
        owner: null,
        kind: null,
        token: 0,
      };

      dialog.addEventListener('click', (event) => {
        // A click on the backdrop lands on the dialog itself
        if (event.target === dialog || event.target.closest('[data-close]')) {
          dialog.close();
          return;
        }

        const choose = event.target.closest('[data-choose]');
        if (choose && popup.owner) {
          popup.owner.choose(popup.kind, choose.closest('[data-option]'));
          dialog.close();
        }
      });
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('bible-acc-locked');
        popup.owner = null;
      });

      return popup;
    };

    class BibleAccessories extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;

        const data = this.dataset;
        this.labels = {
          hint: data.labelHint,
          choose: data.labelChoose,
          selected: data.labelSelected,
          loading: data.labelLoading,
          empty: data.labelEmpty,
          error: data.labelError,
          close: data.labelClose,
          include: data.labelInclude,
        };

        const picks = this.querySelector('author-picks');
        const currency = (picks && picks.dataset.currency) || 'AUD';
        let format = null;
        try {
          format = new Intl.NumberFormat('en-AU', { style: 'currency', currency });
        } catch (error) {}
        this.money = (cents) => (format ? format.format(cents / 100) : `$${(cents / 100).toFixed(2)}`);

        this.addEventListener('click', (event) => {
          const link = event.target.closest('[data-popup-open]');
          if (!link) return;
          // Let people open the collection in a new tab as normal
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
          if (typeof HTMLDialogElement !== 'function') return;

          event.preventDefault();
          this.open(link);
        });

        // Once someone ticks, unticks or chooses, leave that tile as they set it
        this.addEventListener('change', (event) => {
          const tile = event.isTrusted && event.target.closest('[data-kind]');
          if (tile) touchedKinds.add(tile.dataset.kind);
        });

        // Put Algolia's first in-stock item in each tile before the block is seen
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.syncWithAlgolia();
            },
            { rootMargin: '800px 0px' }
          );
          this.observer.observe(this);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      tileCollections(tiles) {
        return tiles
          .filter((tile) => tile.dataset.collectionId)
          .map((tile) => ({ id: tile.dataset.collectionId, handle: tile.dataset.collectionHandle || '' }));
      }

      async syncWithAlgolia() {
        if (synced || !getAlgolia()) return;
        synced = true;

        const tiles = [...this.querySelectorAll('[data-kind][data-collection-id]:not([data-pinned])')];
        const requests = algoliaItems(this.tileCollections(tiles));

        await Promise.all(
          tiles.map(async (tile) => {
            const kind = tile.dataset.kind;
            try {
              const items = await requests[tile.dataset.collectionId];
              const first = items && items[0];
              const input = tile.querySelector('.author-picks__input');
              if (!first || !input || first.variantId === input.value || touchedKinds.has(kind)) return;

              const holder = document.createElement('div');
              holder.innerHTML = optionHtml(first, this.money, this.labels.choose);
              this.choose(kind, holder.firstElementChild, { keepTick: true });
            } catch (error) {
              console.info(`Complete your Bible: kept Shopify's order for ${kind}`, error);
            }
          })
        );
      }

      async open(link) {
        const tile = link.closest('[data-kind]');
        const kind = tile.dataset.kind;
        const current = tile.querySelector('.author-picks__input');
        const view = getPopup(this.labels);
        const token = ++view.token;

        view.owner = this;
        view.kind = kind;
        view.title.textContent = link.dataset.popupTitle || link.textContent.trim();
        view.note.textContent = link.dataset.popupNote || '';
        view.all.href = link.href;
        view.all.textContent = `${link.dataset.popupAll || link.textContent.trim()} →`;
        view.body.innerHTML = `<p class="bible-acc-dialog__message">${escapeHtml(this.labels.loading)}</p>`;
        view.body.scrollTop = 0;

        document.documentElement.classList.add('bible-acc-locked');
        if (!view.dialog.open) view.dialog.showModal();

        let html = null;
        // Algolia first, so the order matches the collection page
        if (tile.dataset.collectionId && getAlgolia()) {
          try {
            const items = await algoliaItems(this.tileCollections([tile]))[tile.dataset.collectionId];
            // Nothing back from Algolia: let Shopify's list have a go instead
            if (items.length === 0) throw new Error(`No in-stock results for collection ${tile.dataset.collectionId}`);
            html = `<div class="bible-acc-options" data-options>${items
              .slice(0, POPUP_LIMIT)
              .map((item) => optionHtml(item, this.money, this.labels.choose))
              .join('')}</div>`;
          } catch (error) {
            console.info('Complete your Bible: Algolia unavailable, using Shopify order', error);
          }
        }

        try {
          if (html === null) html = await loadSectionOptions(link.href);
          if (token !== view.token) return;
          view.body.innerHTML = html;

          const options = [...view.body.querySelectorAll('[data-option]')];
          if (options.length === 0) {
            view.body.innerHTML = `<p class="bible-acc-dialog__message">${escapeHtml(this.labels.empty)}</p>`;
            return;
          }

          options.forEach((option) => {
            const isCurrent = current && option.dataset.variantId === current.value;
            const button = option.querySelector('[data-choose]');
            option.classList.toggle('is-current', Boolean(isCurrent));
            if (button) {
              button.textContent = isCurrent ? this.labels.selected : this.labels.choose;
              button.setAttribute('aria-pressed', isCurrent ? 'true' : 'false');
            }
          });
        } catch (error) {
          if (token !== view.token) return;
          console.error('Complete your Bible: popup failed to load', error);
          view.body.innerHTML = `<p class="bible-acc-dialog__message">${escapeHtml(this.labels.error)}</p>`;
        }
      }

      // Swaps an item into this tile type in every copy of the block (desktop and
      // mobile) and updates the total and button. Chosen from the popup, it's
      // ticked; swapped in from Algolia (keepTick), the tick is left as it is.
      choose(kind, option, { keepTick = false } = {}) {
        if (!option) return;
        if (!keepTick) touchedKinds.add(kind);
        const name = option.querySelector('[data-option-name]');
        const image = option.querySelector('[data-option-image]');
        const price = option.querySelector('[data-option-price]');

        document.querySelectorAll(`bible-accessories [data-kind="${kind}"]`).forEach((tile) => {
          const input = tile.querySelector('.author-picks__input');
          if (!input) return;

          input.value = option.dataset.variantId;
          input.dataset.price = option.dataset.price;
          if (!keepTick) input.checked = true;

          tile.querySelectorAll('[data-swap-image], [data-swap-name]').forEach((link) => {
            link.href = option.dataset.url;
          });

          const tileName = tile.querySelector('[data-swap-name]');
          if (tileName && name) {
            tileName.textContent = name.textContent.trim();
            tileName.title = option.dataset.title || '';
          }

          const tileImage = tile.querySelector('[data-swap-image]');
          if (tileImage && image) {
            tileImage.innerHTML = image.innerHTML;
            const img = tileImage.querySelector('img');
            if (img) img.sizes = TILE_SIZES;
          }

          const tilePrice = tile.querySelector('[data-swap-price]');
          if (tilePrice && price) tilePrice.innerHTML = price.innerHTML;

          const sr = tile.querySelector('[data-swap-sr]');
          if (sr && name) sr.textContent = `${this.labels.include} ${name.textContent.trim()}`;

          // The author picks element listens for this to update the total and button
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    }

    customElements.define('bible-accessories', BibleAccessories);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-staff-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('staff-video')) {
    class StaffVideo extends HTMLElement {
      connectedCallback() {
        // Move to <body> so the player sits above the product layout, like the zoom popup.
        // Any copy left over from a theme editor refresh is removed first.
        if (this.parentElement !== document.body) {
          document.querySelectorAll('body > staff-video').forEach((el) => el.remove());
          document.body.appendChild(this);
          return;
        }
        if (this.isReady) return;
        this.isReady = true;
        this.init();
      }

      disconnectedCallback() {
        this.stickyObserver?.disconnect();
        clearTimeout(this.showTimer);
        if (this.onFocusIn) document.removeEventListener('focusin', this.onFocusIn);
        if (this.onKeyDown) document.removeEventListener('keydown', this.onKeyDown);
      }

      init() {
        this.player = this.querySelector('[data-staff-video-player]');
        this.video = this.querySelector('video');
        this.expandButton = this.querySelector('[data-staff-video-expand]');
        this.openButton = this.querySelector('[data-staff-video-open]');
        this.closeButton = this.querySelector('[data-staff-video-close]');
        this.backdrop = this.querySelector('[data-staff-video-backdrop]');
        this.addButton = this.querySelector('[data-staff-video-add]');
        this.statusEl = this.querySelector('[data-staff-video-status]');
        this.storageKey = 'staff-video-closed:' + this.dataset.product;

        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        if (!designMode && this.wasClosed()) {
          this.remove();
          return;
        }

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = Boolean(navigator.connection && navigator.connection.saveData);
        this.autoplay = !reduceMotion && !saveData;

        this.video.addEventListener('playing', () => this.classList.add('is-playing'));
        this.video.addEventListener('pause', () => this.classList.remove('is-playing'));

        this.expandButton.addEventListener('click', () => this.expand());
        this.openButton.addEventListener('click', () => this.expand());
        this.closeButton.addEventListener('click', () => {
          if (this.isExpanded()) {
            this.collapse();
          } else {
            this.close();
          }
        });
        this.backdrop.addEventListener('click', () => this.collapse());
        this.addButton?.addEventListener('click', () => this.addToCart());

        this.onKeyDown = (e) => {
          if (e.key === 'Escape' && this.isExpanded()) this.collapse();
        };
        document.addEventListener('keydown', this.onKeyDown);

        // Keep keyboard focus inside the larger player while it's open
        this.onFocusIn = (e) => {
          if (this.isExpanded() && !this.player.contains(e.target)) this.closeButton.focus();
        };
        document.addEventListener('focusin', this.onFocusIn);

        this.watchStickyBar();

        const start = () => {
          this.showTimer = setTimeout(() => this.show(), designMode ? 0 : 1500);
        };
        if (document.readyState === 'complete') {
          start();
        } else {
          window.addEventListener('load', start, { once: true });
        }
      }

      isExpanded() {
        return this.classList.contains('is-expanded');
      }

      wasClosed() {
        try {
          return sessionStorage.getItem(this.storageKey) === '1';
        } catch (e) {
          return false;
        }
      }

      loadSource() {
        if (this.video.getAttribute('src')) return;
        const { hls, mp4 } = this.dataset;
        const canPlayHls = this.video.canPlayType('application/vnd.apple.mpegurl') !== '';

        if (!hls || (!canPlayHls && mp4)) {
          this.video.src = mp4;
          return;
        }

        this.video.src = hls;
        // If the streaming version won't play, switch to the MP4
        if (mp4) {
          this.video.addEventListener(
            'error',
            () => {
              this.video.src = mp4;
              if (this.autoplay || this.isExpanded()) this.video.play()?.catch(() => {});
            },
            { once: true }
          );
        }
      }

      playMuted() {
        this.video.muted = true;
        this.video.loop = true;
        // Some phones block autoplay (e.g. iPhone Low Power Mode). The still image and play button stay.
        this.video.play()?.catch(() => {});
      }

      show() {
        if (this.dataset.poster) this.video.poster = this.dataset.poster;
        this.hidden = false;
        // Wait a frame so the slide-in transition runs
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.classList.add('is-visible'));
        });
        if (this.autoplay) {
          this.loadSource();
          this.playMuted();
        }
      }

      expand() {
        this.loadSource();
        this.setStatus('');
        this.classList.add('is-expanded');
        this.player.setAttribute('role', 'dialog');
        this.player.setAttribute('aria-modal', 'true');
        this.backdrop.hidden = false;
        document.body.style.overflow = 'hidden';

        // Start from the beginning with sound, so the whole recommendation is heard
        this.video.loop = false;
        this.video.muted = false;
        this.video.controls = true;
        this.video.currentTime = 0;
        this.video.play()?.catch(() => {});

        this.closeButton.setAttribute('aria-label', 'Close larger video');
        this.closeButton.focus();
      }

      collapse({ returnFocus = true } = {}) {
        if (!this.isExpanded()) return;
        this.classList.remove('is-expanded');
        this.player.setAttribute('role', 'region');
        this.player.removeAttribute('aria-modal');
        this.backdrop.hidden = true;
        document.body.style.overflow = '';

        this.video.controls = false;
        if (this.autoplay) {
          this.playMuted();
        } else {
          this.video.muted = true;
          this.video.pause();
        }

        this.closeButton.setAttribute('aria-label', 'Close video');
        if (returnFocus) this.openButton.focus();
      }

      close() {
        try {
          sessionStorage.setItem(this.storageKey, '1');
        } catch (e) {}

        this.classList.remove('is-visible');
        this.video.pause();
        document.removeEventListener('focusin', this.onFocusIn);

        setTimeout(() => {
          // Stop any download still in progress
          this.video.removeAttribute('src');
          this.video.load();
          this.remove();
        }, 450);
      }

      setStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        this.statusEl.classList.toggle('is-error', isError);
      }

      // Same add-to-cart request as the Essential [author] picks. On success the larger
      // player closes and the theme's cart:update event opens the cart drawer.
      async addToCart() {
        if (this.isAdding || !this.addButton) return;
        this.isAdding = true;
        this.setStatus('');
        // aria-disabled rather than disabled, so keyboard focus stays on the button
        this.addButton.setAttribute('aria-disabled', 'true');
        this.addButton.setAttribute('aria-busy', 'true');
        this.addButton.textContent = 'Adding…';

        // The theme declares Theme as a global const, so it isn't on window
        const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
        let addUrl = routes.cart_add_url || '/cart/add.js';
        if (!addUrl.endsWith('.js')) addUrl += '.js';
        const sectionIds = [...document.querySelectorAll('cart-component')]
          .map((element) => element.dataset.sectionId)
          .filter(Boolean);

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || '');
          }

          // Close the larger player first so the cart drawer isn't hidden behind it
          this.collapse({ returnFocus: false });
          this.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: {},
                sourceId: 'staff-video',
                data: { source: 'product-form', itemCount: 1, sections: data.sections },
              },
            })
          );
        } catch (error) {
          console.error('Staff video: add to cart failed', error);
          this.setStatus((error && error.message) || "Sorry, we couldn't add this to your cart.", true);
        } finally {
          this.isAdding = false;
          this.addButton.removeAttribute('aria-disabled');
          this.addButton.removeAttribute('aria-busy');
          this.addButton.textContent = this.addButton.dataset.label;
        }
      }

      // On phones the Add to cart bar runs along the bottom of the screen, so the
      // player moves up above it while the bar is showing.
      watchStickyBar() {
        const sticky = document.querySelector('[data-product-sticky]');
        if (!sticky) return;

        const update = () => {
          const lift = sticky.isConnected && sticky.classList.contains('is-active') ? sticky.offsetHeight + 8 : 0;
          this.style.setProperty('--staff-video-lift', lift + 'px');
        };

        this.stickyObserver = new MutationObserver(update);
        this.stickyObserver.observe(sticky, { attributes: true, attributeFilter: ['class'] });
        window.addEventListener('resize', update, { passive: true });
        update();
      }
    }

    customElements.define('staff-video', StaffVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
